import { useEffect, useState, useCallback } from "react";

const KEY = "compare_ids";
const EVT = "compare_change";

export function useCompare() {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    const refresh = () => {
      try { setIds(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch {}
    };
    window.addEventListener(EVT, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(EVT, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  const persist = useCallback((arr) => {
    localStorage.setItem(KEY, JSON.stringify(arr));
    window.dispatchEvent(new Event(EVT));
  }, []);

  const toggle = useCallback((id) => {
    const arr = JSON.parse(localStorage.getItem(KEY) || "[]");
    let next;
    if (arr.includes(id)) {
      next = arr.filter((x) => x !== id);
    } else if (arr.length >= 3) {
      next = [...arr.slice(1), id];
    } else {
      next = [...arr, id];
    }
    persist(next);
    return next.includes(id);
  }, [persist]);

  const clear = useCallback(() => persist([]), [persist]);
  const remove = useCallback((id) => {
    const arr = JSON.parse(localStorage.getItem(KEY) || "[]");
    persist(arr.filter((x) => x !== id));
  }, [persist]);

  return { ids, toggle, clear, remove, count: ids.length };
}
